const EXPODOM_TENT_URL = "https://www.expodom.hu/articles/kerti-sator/";
const EXPODOM_FOLDING_PAVILION_URL = "https://www.expodom.hu/articles/osszecsukhato-pavilon/";

export default function ExpodomNotice() {
  return (
    <section className="bg-white pb-16">
      <div className="mx-auto max-w-4xl px-6 text-center">
        <p className="text-base leading-8 text-gray-700 md:text-lg">
          Tánccsoportunk fellépései és közösségi programjai során elengedhetetlen a
          gyors és mobil árnyékolás. Partnerünk, az Expodom.hu jóvoltából egy modern{" "}
          <a
            href={EXPODOM_TENT_URL}
            target="_blank"
            rel="noreferrer"
            className="font-semibold text-primary underline underline-offset-4"
          >
            kerti sátor
          </a>{" "}
          ad otthont a háttérmunkálatoknak és a pihenésnek. Ha Önnek is stabil{" "}
          <a
            href={EXPODOM_FOLDING_PAVILION_URL}
            target="_blank"
            rel="noreferrer"
            className="font-semibold text-primary underline underline-offset-4"
          >
            összecsukható pavilon
          </a>{" "}
          vagy rendezvénytechnikai kiegészítő kell, látogasson el az Expodom oldalára!
        </p>
      </div>
    </section>
  );
}
